import React from "react";

import { useIntl } from "react-intl";

import ContentLayout from "Components/ContentLayout";
import { APP_NAME } from "Constants/documentationUrls";
import { BackLink } from "ds/Button";
import useDecodedParams from "Hooks/useDecodedParams";

import Form from "../components/Form";

import * as S from "./Form.styles";

const FormPage = () => {
  const intl = useIntl();
  const { organizationId } = useDecodedParams<{ organizationId: string }>();

  return (
    <S.Layout>
      <ContentLayout>
        <S.Header>
          <BackLink
            to={`/${organizationId}/-/billing/vouchers`}
            from="vouchers"
            capitalized={false}
          />
          <S.Heading tag="h2">
            {intl.formatMessage({ id: "voucher.form.title" })}
          </S.Heading>
          <S.Intro>
            {intl.formatMessage(
              { id: "vouchers.intro" },
              { appName: APP_NAME }
            )}
          </S.Intro>
        </S.Header>

        <S.FormWrapper>
          <Form />
        </S.FormWrapper>
      </ContentLayout>
    </S.Layout>
  );
};

export default FormPage;
